/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RollupType } from '../models/RollupType';
import type { RollupTypeRequest } from '../models/RollupTypeRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminRollupTypeService {

    /**
     * get list of roll-up types
     * @returns any Success
     * @throws ApiError
     */
    public static listAdminRollUpTypes({
        surveyJobProfileId,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * SurveyJobProfile ID
         */
        surveyJobProfileId: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        ignorePagination?: boolean,
    }): CancelablePromise<{
        rows?: Array<RollupType>;
        count?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/rollupType',
            query: {
                'surveyJobProfileId': surveyJobProfileId,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create rollupType
     * @returns RollupType Success
     * @throws ApiError
     */
    public static createRollupType({
        requestBody,
    }: {
        requestBody: RollupTypeRequest,
    }): CancelablePromise<RollupType> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/rollupType',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Roll-Up Type Information
     * @returns RollupType Success
     * @throws ApiError
     */
    public static updateRollUpType({
        id,
        requestBody,
    }: {
        /**
         * Roll-Up Type ID
         */
        id: string,
        requestBody: RollupTypeRequest,
    }): CancelablePromise<RollupType> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/rollupType/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Roll-Up Type
     * @returns any Success
     * @throws ApiError
     */
    public static deleteRollUpType({
        id,
    }: {
        /**
         * Roll-Up Type ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/rollupType/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Roll-Up Type Priority
     * @returns RollupType Success
     * @throws ApiError
     */
    public static updateRollupTypePriority({
        id,
        requestBody,
    }: {
        /**
         * Roll-Up Type ID
         */
        id: string,
        requestBody: {
            direction: 'UP' | 'DOWN';
        },
    }): CancelablePromise<RollupType> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/rollupType/{id}/priority',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
